// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_g8-a";
export var fulfillmentFormRail = "_g8-9";
export var headerTitleRow = "_g8-c";
export var orderDetailsWrapper = "_g8-7";
export var orderLinkTrigger = "_g8-2";
export var paymentInformationGrid = "_g8-h";
export var paymentSummaryColumn = "_g8-i";
export var shipmentContainer = "_g8-b";
export var shipmentDetailsMainPane = "_g8-8";
export var shipmentNavigationCard = "_g8-5";
export var shipmentNavigationRail = "_g8-3";
export var shipmentNavigationRailHeader = "_g8-4";
export var shipmentSummaryFact = "_g8-e";
export var shipmentSummaryGrid = "_g8-d";
export var shipmentSummaryMetadataRow = "_g8-f";
export var shipmentSummaryTags = "_g8-g";
export var shipmentWorkspace = "_g8-0";
export var shipmentWorkspaceContent = "_g8-6";
export var shipmentWorkspaceHeader = "_g8-1";